import App from '../index.js';

App.CrawlIndex = (function () {

    const elRescrapeModal = $('#rescrapeWebpage');

    function initDataTable (el) {
        let options = {
            destroy: true,
            serverSide: true,
            processing: true,
            searching: true,
            deferRender: true,
            stateSave: false,
            pageLength: 25,
            lengthMenu: [ [ 10, 25, 50, 100 ], [ 10, 25, 50, 100 ] ],
            lengthChange: true,
            language: {
                searchPlaceholder: "Search",
                search: "",
            },
            layout: {
                topStart: [ { div: { className: 'table-headline' } }, 'pageLength' ],
                topEnd: 'search',
                bottomStart: 'info',
                bottomEnd: 'paging',
            },
            initComplete: function () {
                let elDataTableWrapper = $(this).closest('.data-table-wrapper');
                elDataTableWrapper.find('[type="search"]').removeClass('form-control-sm').closest('label').addClass('form-group search-box').prepend('<i class="search-icon fas fa-search"></i>');
                elDataTableWrapper.find('.dt-search .form-group, .dt-search .search-box').wrapAll('<div class="form-row justify-content-end align-items-center text-end"></div>');

            },
            order: [[ 0, "desc" ]],
            ajax: {
                url: el.data('query-url'),
                type: "POST",
                data: function (d) {
                    d._token = $('meta[name="csrf-token"]').attr('content');
                }
            },
            columns: [
                {
                    data: 'url',
                    className: 'datatable-url'
                },
                {
                    data: 'title',
                    className: 'datatable-title'
                },
                {
                    data: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'datatable-action'
                }
            ]
        };

        el.DataTable(options);
    }

    function rescrapeWebpage () {
        let name = $(this).data('name');
        let route = $(this).data('url');
        elRescrapeModal.find('form').attr('action', route);
        elRescrapeModal.find('.header-sub-text').html(`Are you sure you want to rescrape ${name}?`);
    }

    return {
        init: function(){
            initDataTable($('#crawl_indexes_table'));
            App.dataTableTypeDelay($('.dt-container .dt-search input[type="search"]'));

            $('body').on('click', '.rescrape-webpage', rescrapeWebpage);

            elRescrapeModal.on('hide.bs.modal', function () {
                $('.header-sub-text').empty();
            });
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.bots.crawl.index', App.CrawlIndex.init);

export default App.CrawlIndex;
